import { render } from "./PreviousLectureTeacher.vue?vue&type=template&id=77402c0c&scoped=true"
import script from "./PreviousLectureTeacher.vue?vue&type=script&lang=js"
export * from "./PreviousLectureTeacher.vue?vue&type=script&lang=js"

import "./PreviousLectureTeacher.vue?vue&type=style&index=0&id=77402c0c&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\CMRF\\cmrf_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77402c0c"]])

export default __exports__